module.exports = __webpack_public_path__ + "img/C2_09.333385cf.png";